import { render, staticRenderFns } from "./survey-instructions.vue?vue&type=template&id=54d3bd8c&scoped=true&"
import script from "./survey-instructions.vue?vue&type=script&lang=js&"
export * from "./survey-instructions.vue?vue&type=script&lang=js&"
import style0 from "./survey-instructions.vue?vue&type=style&index=0&id=54d3bd8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d3bd8c",
  null
  
)

component.options.__file = "survey-instructions.vue"
export default component.exports